/*--------------------------------------
SLIDER BANNER
 --------------------------------------*/
SliderBanner = {
  init: function () {
    var swiper = new Swiper(".swiper-sliderBanner", {
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
      allowTouchMove: true,
      speed: 1000,
      loop: true,
      keyboard: {
        enabled: true,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + '<i></i>' + '<b></b>' + '</span>';
        },
      },
      
    });


     //SI ÉS MÒBIL
     var isMobile = {
      Android: function () {
          return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function () {
          return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function () {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function () {
          return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function () {
          return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
      },
      any: function () {
          return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
      }
  };



  if (isMobile.any()) {
  } else {
      $('.slider-banner__info__content a').on('pointerdown',
          function pointerHandler(event) {
              window.location.href = $(this).attr('href');
          }
      );
  }
  }
};


$(function () {
  SliderBanner.init();
});